import React from 'react'
import isEmpty from 'lodash.isempty'
import {SingleTeaserInterface} from '../../../types/teaser'
import {SinglePromotionList} from '../views/singlePromotionList'
import ShowroomTitle from '../ui/ShowroomTitle'
import Brands from '../../../utils/brand/brand'
import {StructuredData} from '../../../structuredData/StructuredData'
import BasicStage from '../ui/BasicStage'
import {ListingModels} from '../listing/listingModels'
import {FiltersContainer} from '../filters/filtersContainer'
import {styled} from '@volkswagen-onehub/components-core'
import containerBottomStage from '../../../assets/css-vars/containerBottomStage'
import TabGroup from '../filters/TabGroup'
import Teaser from '../banner/teaser'
import {normalizeToSlugs} from '../../../utils/slug/normalizeToSlugs'
import {MultiModelPromotionList} from '../views/MultiModelPromotionList'
import {Loading} from '../../../common/components/general/loading'
import {globalColors} from '../../../utils/style/globalColors'

const AppWrapper = styled.main`
    ${containerBottomStage}
`

const BottomStageWrapper = styled.div`
    ${containerBottomStage}
    background-color: ${globalColors.white000};
    padding-bottom: 44px;
`

interface PromotionRouteProps {
    isShowroom: boolean
    modelFromCms: string
    singleCar: {name: string}
    brandFromState: string
    stageImage?: {image_desktop: string; image_mobile: string}
    t: (key: string, options?: any) => string
    currentMonth: string
    overviewStructuredData: any
    allTeasers: SingleTeaserInterface[]
}

export const PromotionContent: React.FC<PromotionRouteProps> = ({
    isShowroom,
    modelFromCms,
    singleCar,
    brandFromState,
    stageImage,
    t,
    currentMonth,
    overviewStructuredData,
    allTeasers,
}) => {
    const [showroomStatus, setShowroomStatus] = React.useState({
        hasResolvedPromotions: false,
        hasAnyPromotions: false,
        modelNames: [] as string[],
    })

    React.useEffect(() => {
        setShowroomStatus({
            hasResolvedPromotions: false,
            hasAnyPromotions: false,
            modelNames: [],
        })
    }, [modelFromCms])

    const handleShowroomStatus = React.useCallback(
        (status: {
            hasResolvedPromotions: boolean
            hasAnyPromotions: boolean
            modelNames: string[]
        }) => {
            setShowroomStatus(status)
        },
        []
    )

    return (
        <>
            {isShowroom && modelFromCms.length ? (
                <div>
                    {(() => {
                        const slugs = normalizeToSlugs(modelFromCms)
                        const namesForHeader =
                            showroomStatus.modelNames.length > 0
                                ? showroomStatus.modelNames
                                : singleCar && singleCar.name
                                ? [singleCar.name]
                                : []
                        const showNoPromoMessage =
                            showroomStatus.hasResolvedPromotions &&
                            !showroomStatus.hasAnyPromotions

                        return (
                            <>
                                <ShowroomTitle
                                    modelHasPromos={
                                        showroomStatus.hasAnyPromotions
                                    }
                                    showNoPromoMessage={
                                        showroomStatus.hasResolvedPromotions
                                            ? showNoPromoMessage
                                            : false
                                    }
                                    modelNames={namesForHeader}
                                    modelName={namesForHeader[0]}
                                />

                                {!showroomStatus.hasResolvedPromotions && (
                                    <Loading />
                                )}

                                {slugs.length > 1 ? (
                                    <MultiModelPromotionList
                                        modelSlugs={slugs}
                                        onStatusChange={handleShowroomStatus}
                                    />
                                ) : (
                                    <SinglePromotionList
                                        modelFromCms={slugs[0]}
                                        onStatusChange={handleShowroomStatus}
                                    />
                                )}
                            </>
                        )
                    })()}
                </div>
            ) : (
                <div>
                    {brandFromState === Brands.VW ? (
                        <StructuredData data={overviewStructuredData} />
                    ) : undefined}

                    {stageImage ? (
                        <BasicStage
                            title={t('title', {month: currentMonth})}
                            promotionText={t('abstract')}
                            imageName={stageImage.image_desktop}
                            imageNameMobile={stageImage.image_mobile}
                            imageAlt={''}
                            whiteBackground
                        />
                    ) : undefined}

                    <AppWrapper>
                        <BottomStageWrapper>
                            {brandFromState === Brands.VIC ? (
                                <TabGroup />
                            ) : undefined}
                            <FiltersContainer />
                        </BottomStageWrapper>

                        <ListingModels />

                        {!isEmpty(allTeasers) ? (
                            <>
                                {allTeasers.map(
                                    (
                                        teaser: SingleTeaserInterface,
                                        index: number
                                    ) => (
                                        <Teaser
                                            teaser={teaser}
                                            index={index}
                                            key={teaser.id}
                                        />
                                    )
                                )}
                            </>
                        ) : undefined}
                    </AppWrapper>
                </div>
            )}
        </>
    )
}
